import {
  UI_START_LOADING,
  UI_STOP_LOADING,
  SHOW_BAR,
  HIDE_BAR,
  EDIT_MODE_ON,
  EDIT_MODE_OFF,
  LIST_PULL_REFRESHING_ON,
  LIST_PULL_REFRESHING_OFF,
  SET_UI_FLAG
} from "./actionTypes";

export const uiStartLoading = () => {
  //console.log("Switching on spinner");
  return {
    type: UI_START_LOADING
  };
};

export const uiStopLoading = () => {
  //console.log("switching OFF spinner");
  return {
    type: UI_STOP_LOADING
  };
};

export const uiShowBar = () => {
  //logger("BASIC","ACTION uiShowBar", "Show icons bar");
  return {
    type: SHOW_BAR
  };
};

export const uiHideBar = () => {
  //logger("BASIC","uiHideBar", "Hide icons bar");
  return {
    type: HIDE_BAR
  };
};

export const editModeOn = () => {
  //logger("BASIC","editModeOn", "Enabling edit");
  return {
    type: EDIT_MODE_ON
  };
};

export const editModeOff = () => {
  //logger("BASIC","editModeOff", "Switching off edit mode");
  return {
    type: EDIT_MODE_OFF
  };
};

export const pullRefreshOn = () => {
  //logger("DEBUG","pullRefreshOn", "On pull refresh flag");
  return {
    type: LIST_PULL_REFRESHING_ON
  };
};

export const pullRefreshOff = () => {
  //logger("DEBUG","pullRefreshOff","Off pull refresh flag");
  return {
    type: LIST_PULL_REFRESHING_OFF
  };
};

export const setUiFlag = (flagName, status) => {
  return {
    type: SET_UI_FLAG,
    flagName: flagName,
    status: status
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/ui.js